@if (showField$ | async) {
  <div>
    <div class="form-row">
      @if (columnList$ | async; as columnList) {
        @for (c of columnList; track c) {
          @if (c.subfield) {
            <nuso-form-control
              [field]="c.subfield"
              [ngClass]="{ visible: c.visible }"
            ></nuso-form-control>
          } @else {
            <div class="spacer">&nbsp;</div>
          }
        }
      }
    </div>
    @if (hasDanger() && !isDisabled()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
  </div>
}
